var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-shop-selector" },
    [
      _c(
        "yxt-tabs",
        {
          attrs: {
            "drawer-top": _vm.drawerTop,
            "before-leave": _vm.tabBeforeLeave,
          },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        _vm._l(_vm.setTabs, function (tab, index) {
          return _c(
            "yxt-tab-pane",
            { key: index, attrs: { name: tab.value } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v(_vm._s(tab.label)),
              ]),
              _c(
                "yxt-row",
                {
                  staticClass: "yxtbiz-shop-selector-container",
                  attrs: { type: "flex" },
                },
                [
                  _vm.activeName === tab.value
                    ? [
                        _c(tab.component, {
                          tag: "component",
                          on: { update: _vm.update, onProcess: _vm.onProcess },
                          model: {
                            value: _vm.selectedProps,
                            callback: function ($$v) {
                              _vm.selectedProps = $$v
                            },
                            expression: "selectedProps",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _c(
                    "aside",
                    { staticClass: "yxtbiz-shop-selector__right" },
                    [
                      _c(
                        "div",
                        { staticClass: "yxtbiz-shop-selector__right_count" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm
                                .$t(
                                  "pc_biz_shoptour_select_info" /*已选择（{0}/1000）*/,
                                  [_vm.list.length, _vm.limit]
                                )
                                .d(
                                  "已选择（" + _vm.list.length + "/" + _vm.limit
                                )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticStyle: { height: "100%" } },
                        [
                          _c("yxtbiz-virtual-list", {
                            staticStyle: { height: "100%", overflow: "hidden" },
                            attrs: {
                              "is-scrollbar": "",
                              "data-sources": _vm.list,
                              "data-key": "storeId",
                              "estimate-size": 32,
                              keeps: 50,
                              "item-tag": "div",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var source = ref.source
                                    return [
                                      _c(
                                        "yxt-tag",
                                        {
                                          key: source.storeId,
                                          staticClass: "mb5 tag",
                                          attrs: {
                                            size: "small",
                                            type: "info",
                                            closable: "",
                                          },
                                          on: {
                                            close: function ($event) {
                                              return _vm.deleteItem(source)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "yxtbiz-user-selector-tag",
                                            },
                                            [_vm._v(_vm._s(source.storeName))]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "yxt-button",
                        {
                          staticClass:
                            "yxtbiz-shop-clear font-size-12 color-gray-9 hover-primary-6",
                          attrs: {
                            type: "text",
                            disabled: _vm.list.length === 0,
                          },
                          on: { click: _vm.clear },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("pc_biz_shoptour_clear_all" /*清除所有*/)
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }